import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PiCaretDown, PiCaretUp } from "react-icons/pi";

/**
 * Composant qui permet de filtrer les données d'un tableau ex : Sans fil, LAN, Autres...
 * @param {array} arrayValues - tableau de valeurs pour filtrer les données
 * @param {number} currentSlide - index de la valeur pour filtrer les données
 * @param {function} setCurrentSlide - fonction d'état pour mettre à jour currentSlide et changer la valeur du filtre
 */
export default function CarousselNav({
  arrayValues,
  currentSlide,
  setCurrentSlide,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="caroussel">
      <div className="caroussel-view">
        <p>{t(arrayValues[currentSlide])}</p>
        <button
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          {!isOpen ? <PiCaretDown /> : <PiCaretUp />}
        </button>
      </div>
      <div className={`caroussel-list ${isOpen ? "caroussel-list-open" : ""}`}>
        <ul>
          {arrayValues.map((value, index) => {
            if (index !== currentSlide) {
              return (
                <li key={value}>
                  <button
                    onClick={() => {
                      setCurrentSlide(index);
                      setIsOpen(false);
                    }}
                  >
                    {t(value)}
                  </button>
                </li>
              );
            }
          })}
        </ul>
      </div>
    </div>
  );
}
